<template>

    <p> welcome, admin </p>

</template>

<script>

    export default {
        name: 'admin-dashboard'
    }

</script>

<style scoped>

    p{

        height: 100%;
        width: 100%;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 22px;
        color: #333;
    }

</style>